import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavParams } from '@ionic/angular';
import { CVCService } from 'src/app/services/cvc.service';
import { UIService } from 'src/app/services/ui.service';
import { Usuario } from 'src/app/services/usuario';

@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.page.html',
  styleUrls: ['./usuario.page.scss'],
})
export class UsuarioPage implements OnInit {


  usu = new Usuario();
  titulo = 'Registre-se como um Novo Usuário:';
  editMode = false;
  editSenha = true;
  editEmail = true;

  constructor(private modalCtrl: ModalController,
    private navParams: NavParams,
    private cvcapi: CVCService,
    private router: Router,
    private ui: UIService) { }


  ngOnInit() {

    this.setupView(false);

    if (this.navParams.get('edit') === true) {

      this.setupView(true);

      this.cvcapi.getUsuario().subscribe(
        (res) => {
          if (res.erro) {
            this.ui.alerta(res.erro.replace(/;/g, '<br>'));
            this.dismiss(false);
          } else {
            this.usu = res;
          }
        }
        , (err) => {
          console.log(err);
          this.ui.alerta(err.message);
          this.dismiss(false);
        }
      );

    }
  }

  setupView(editar: boolean) {
    this.editMode = editar;
    if (this.editMode) {
      this.titulo = 'Meus Dados:';
    } else {
      this.titulo = 'Novo Usuário:';
    }
    this.editSenha = !this.editMode;
    this.editEmail = !this.editMode;
  }

  setupSenha() {
    this.editSenha = true;
  }

  setupEmail() {
    this.editEmail = true;
  }


  sair() {

    if (this.editMode) {
      this.dismiss(false);
    } else {
      this.router.navigateByUrl('login');
    }
  }

  dismiss(result: boolean) {
    this.modalCtrl.dismiss(result);
  }

  registrar(form) {

    let confmsg = 'Confirme seu Email: ';
    let holder = 'Email: ';
    let password = false;
    if (this.editMode) {
      confmsg = 'Informe sua Senha Anterior para realizar a alteração:';
      holder = 'Senha: ';
      password = true;
    }

    this.ui.confirma(confmsg, null, holder, password).then((resp) => {

      if (resp.data === false) {
        return;
      }

      if (this.editMode) {
        form.value.id = this.usu.id;
        if (!this.editEmail) {
          form.value.emailconf = this.usu.email;
        }
        form.value.senhaold = resp.data.info;
        //console.log(form.value);
        //return;
      } else {
        if (resp.data.info !== form.value.email) {
          this.ui.alerta('"Confirme seu Email!');
          return;
        }
        form.value.emailconf = form.value.email;
      }



      this.cvcapi.registrar(form.value, this.editMode).subscribe((res) => {
        if (res.erro) {
          this.ui.alerta(res.erro.replace(/;/g, '<br>'));
        } else {
          if (res.msg) {
            this.ui.alerta(res.msg.replace(/;/g, '<br>')).then(() => {
              // this.sair();
            });
          } else {
            this.sair();
          }
        }
      });

    });

  }

}
